import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CanvasComponent } from './component/global/canvas/canvas.component';
import { HomeComponent } from './component/global/home/home.component';
import { HeadComponent } from './component/layout/head/head.component';
import { FileSaverModule } from 'ngx-filesaver';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import firebase from "firebase/app";
import "firebase/analytics";
import {HttpClientModule, HttpClient} from '@angular/common/http';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
const firebaseConfig = {
  apiKey: "AIzaSyDXoq87rQu90xOYnqlRR8TPRssv--cMn2M",
    authDomain: "entitiesconvertor.firebaseapp.com",
    projectId: "entitiesconvertor",
    storageBucket: "entitiesconvertor.appspot.com",
    messagingSenderId: "1029787383900",
    appId: "1:1029787383900:web:906d70ba324fa009380e99",
    measurementId: "G-168KKV9FXJ"
};

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

@NgModule({
  declarations: [
    AppComponent,
    CanvasComponent,
    HomeComponent,
    HeadComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FileSaverModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot(), // ToastrModule added
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      },
      defaultLanguage: 'fr'
  })

  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
